import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PlacementEffects } from './store/placement.effects';
import { PlacementNamespace, PlacementReducer } from './store/placement.store';

@NgModule({
  imports: [
    StoreModule.forFeature(PlacementNamespace, PlacementReducer),
    EffectsModule.forFeature([PlacementEffects]),
  ],
})
export class PlacementDataModule {}
